<template>
  <section class="ds s-py-45 s-py-xl-75 c-gutter-60">
    <div class="container">
      <div class="row">
        <main class="col-lg-12">
          <article>
            <div class="entry-content">
              <div class="woocommerce">
                <div class="woocommerce-MyAccount-content">
                  <form
                    id="child-form"
                    role="form"
                    style="display: block"
                    v-if="getCurrentCategory.id === 275"
                  >
                    <p class="mm-font __mm" align="center">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>

                    <label class="mm-font __mm">အမျိုးသမီး</label>
                    <br />
                    <br />
                    <label class="form-group">
                      <span class="mm-font __mm __mm">အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="g_name"
                        v-model="love.g_name"
                        required
                      />
                      <span
                        class="error__message"
                        v-if="!love.g_name && isErrorLove.g_name"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ isErrorLove.g_name }}
                      </span>
                    </label>
                    <label class="form-group mm-font">
                      <span class="mm-font __mm">နေ့နံ</span>
                      <div class="dropdown__container">
                        <select
                          name="g_birth_day"
                          v-model="love.g_birth_day"
                          class="mm-font __mm"
                          required
                        >
                          <option value="" class="__mm" selected>
                            နေ့နံရွေးချယ်ပါ
                          </option>
                          <option value="တနင်္ဂနွေ" class="__mm">
                            တနင်္ဂနွေ
                          </option>
                          <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                          <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                          <option value="ဗုဒ္ဓဟူး" class="__mm">
                            ဗုဒ္ဓဟူး
                          </option>
                          <option value="ရာဟု" class="__mm">ရာဟု</option>

                          <option value="ကြာသပတေး" class="__mm">
                            ကြာသပတေး
                          </option>
                          <option value="သောကြာ" class="__mm">သောကြာ</option>
                          <option value="စနေ" class="__mm">စနေ</option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <span
                        class="error__message"
                        v-if="!love.g_birth_day && isErrorLove.g_birth_day"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ isErrorLove.g_birth_day }}
                      </span>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>

                      <md-datepicker
                        :md-disabled-dates="disablePastDates"
                        v-model="love.g_birth_date"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        required
                        ref="datepicker"
                      >
                        <label class="date__picker" v-if="!love.g_birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                      <div
                        class="error__message"
                        v-if="!love.g_birth_date && isErrorLove.g_birth_date"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorLove.g_birth_date }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div class="dropdown__container">
                        <select
                          v-model="love.g_address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '1')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions1"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <div class="dropdown__container">
                        <select
                          v-model="love.g_address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships1.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships1"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ် "
                        v-model="love.g_address"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="
                          (!love.g_address ||
                            !this.love.g_address_division ||
                            !this.love.g_address_township) &&
                          isErrorLove.g_address
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorLove.g_address }}
                      </div>
                    </label>

                    <p style="font-size: 30px">
                      <i class="fa fa-heart" aria-hidden="true"></i>
                    </p>
                    <label class="mm-font __mm">အမျိုးသား</label>
                    <br />
                    <br />
                    <label class="form-group">
                      <span class="mm-font __mm">အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="b_name"
                        v-model="love.b_name"
                        required
                      />
                      <span
                        class="error__message"
                        v-if="!love.b_name && isErrorLove.b_name"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ isErrorLove.b_name }}
                      </span>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">နေ့နံ့</span>
                      <div class="dropdown__container">
                        <select
                          name="b_birth_day"
                          v-model="love.b_birth_day"
                          class="mm-font __mm"
                          required
                        >
                          <option value="" class="__mm" selected>
                            နေ့နံရွေးချယ်ပါ
                          </option>
                          <option value="တနင်္ဂနွေ" class="__mm">
                            တနင်္ဂနွေ
                          </option>
                          <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                          <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                          <option value="ဗုဒ္ဓဟူး" class="__mm">
                            ဗုဒ္ဓဟူး
                          </option>
                          <option value="ရာဟု" class="__mm">ရာဟု</option>

                          <option value="ကြာသပတေး" class="__mm">
                            ကြာသပတေး
                          </option>
                          <option value="သောကြာ" class="__mm">သောကြာ</option>
                          <option value="စနေ" class="__mm">စနေ</option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <span
                        class="error__message"
                        v-if="!love.b_birth_day && isErrorLove.b_birth_day"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ isErrorLove.b_birth_day }}
                      </span>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>
                      <md-datepicker
                        :md-disabled-dates="disablePastDates"
                        v-model="love.b_birth_date"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        required
                      >
                        <label class="date__picker" v-if="!love.b_birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                      <div
                        class="error__message"
                        v-if="!love.b_birth_date && isErrorLove.b_birth_date"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorLove.b_birth_date }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div class="dropdown__container">
                        <select
                          v-model="love.b_address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '2')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions2"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <div class="dropdown__container">
                        <select
                          v-model="love.b_address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships2.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships2"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း  အသေးစိတ်"
                        v-model="love.b_address"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="
                          (!love.b_address ||
                            !this.love.b_address_division ||
                            !this.love.b_address_township) &&
                          isErrorLove.b_address
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorLove.b_address }}
                      </div>
                    </label>

                    <label class="form-group">
                      <span for class="mm-font __mm"
                        >ဆက်သွယ်ရမည့်ဖုန်းနံပါတ်</span
                      >
                      <input
                        type="number"
                        class="form-control"
                        name="phone_number"
                        v-model="love.phone_number"
                        @input="validateFormLove"
                        placeholder="09xxxxxxxxx"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="isErrorLove.phone_number"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorLove.phone_number }}
                      </div>
                    </label>
                    <p class="t_c_agreement">
                      By continuing, you agree to
                      <span @click.prevent="redirectTNC()"
                        >Terms and Conditions.</span
                      >
                    </p>
                    <p>ငွေပေးချေပြီးပါက ဟောစာတမ်းအား (၃) ရက်အတွင်း 'အဖြေများ' စာမျက်နှာတွင် ဝင်ရောက် ကြည့်ရှုနိုင်ပါသည်။</p>
                    <!-- <p>
                      ဉာဏ်ပူဇော်ခ
                      <del>၉၀၀၀</del> ၇၆၅၀
                      ကျပ် ကျသင့်ပါမည်။
                    </p> -->
                    <p>
                      <input
                        @click.prevent="paymentProvider()"
                        :disabled="disabled"
                        type="submit"
                        class="woocommerce-Button button mm-font __mm"
                        name="save_account_details"
                        value="အတည်ပြုမည်"
                      />
                    </p>
                  </form>
                  <form
                    id="child-form"
                    role="form"
                    style="display: block"
                    v-if="getCurrentCategory.id === 11"
                  >
                    <p class="mm-font __mm" align="center">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>
                      <md-datepicker
                        :md-disabled-dates="disablePastDates"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        v-model="child.birth_date"
                        ref="datepicker"
                      >
                        <label class="date__picker" v-if="!child.birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                      <div
                        class="error__message"
                        v-if="!child.birth_date && isErrorChild.birth_date"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.birth_date }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးချိန်</span>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          gap: 10px;
                        "
                      >
                        <div class="dropdown__container">
                          <select
                            class="mm-font __mm"
                            v-model="birth_am_pm"
                            required
                          >
                            <option value="" hidden>နံနက်/ည</option>
                            <option value="နံနက်">နံနက်ပိုင်း</option>
                            <option value="ည">ညနေပိုင်း</option>
                          </select>
                          <i class="pi pi-chevron-down dropdown__icon"></i>
                        </div>
                        <div class="dropdown__container">
                          <select
                            class="mm-font __mm"
                            v-model="birth_clock"
                            required
                          >
                            <option value="" hidden>အချိန်</option>
                            <option
                              v-for="t in [
                                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
                              ]"
                              :key="t"
                              :value="t + 'နာရီ'"
                            >
                              {{ t }} နာရီ
                            </option>
                          </select>
                          <i class="pi pi-chevron-down dropdown__icon"></i>
                        </div>
                      </div>
                      <div
                        class="error__message"
                        v-if="
                          (!birth_am_pm || !birth_clock) &&
                          isErrorChild.birth_time
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.birth_time }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">ဖခင်အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="father_name"
                        v-model="child.father_name"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="!child.father_name && isErrorChild.father_name"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.father_name }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မိခင်အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="mother_name"
                        v-model="child.mother_name"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="!child.mother_name && isErrorChild.mother_name"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.mother_name }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">မွေးရပ်</span>
                      <div class="dropdown__container">
                        <select
                          v-model="child.birth_place_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '2')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions2"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <div class="dropdown__container">
                        <select
                          v-model="child.birth_place_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships2.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships2"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ်"
                        v-model="child.birth_place"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="
                          (!child.birth_place_division ||
                            !this.child.birth_place_township ||
                            !this.child.birth_place) &&
                          isErrorChild.birth_place
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.birth_place }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေ့နံ</span>
                      <div class="dropdown__container">
                        <select
                          class="mm-font __mm"
                          name="nyih_nan"
                          v-model="child.nyih_nan"
                          required
                        >
                          <option value="" class="__mm" selected>
                            နေ့နံရွေးချယ်ပါ
                          </option>
                          <option value="တနင်္ဂနွေ" class="__mm">
                            တနင်္ဂနွေ
                          </option>
                          <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                          <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                          <option value="ဗုဒ္ဓဟူး" class="__mm">
                            ဗုဒ္ဓဟူး
                          </option>
                          <option value="ရာဟု" class="__mm">ရာဟု</option>

                          <option value="ကြာသပတေး" class="__mm">
                            ကြာသပတေး
                          </option>
                          <option value="သောကြာ" class="__mm">သောကြာ</option>
                          <option value="စနေ" class="__mm">စနေ</option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <span
                        class="error__message"
                        v-if="!child.nyih_nan && isErrorChild.nyih_nan"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ isErrorChild.nyih_nan }}
                      </span>
                    </label>

                    <input
                      type="radio"
                      name="gender"
                      v-model="child.gender"
                      value="Male"
                      required
                    />
                    <span for class="mm-font __mm">ယောကျ်ားလေး</span>
                    <input
                      type="radio"
                      name="gender"
                      v-model="child.gender"
                      value="Female"
                      required
                    />
                    <span for class="mm-font __mm">မိန်းကလေး</span>
                    <div
                      class="error__message ml-1"
                      v-if="!child.gender && isErrorChild.gender"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      {{ isErrorChild.gender }}
                    </div>
                    <br />
                    <br />

                    <label class="form-group">
                      <span for class="mm-font __mm"
                        >ဆက်သွယ်ရမည့်ဖုန်းနံပါတ်</span
                      >
                      <input
                        type="number"
                        class="form-control"
                        name="phone_number"
                        v-model="child.phone_number"
                        @input="validateForm"
                        placeholder="09xxxxxxxxx"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="isErrorChild.phone_number"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.phone_number }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div class="dropdown__container">
                        <select
                          v-model="child.address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '1')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions1"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <div class="dropdown__container">
                        <select
                          v-model="child.address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships1.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships1"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ်"
                        v-model="child.address"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="
                          (!child.address ||
                            !this.child.address_division ||
                            !this.child.address_township) &&
                          isErrorChild.address
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ isErrorChild.address }}
                      </div>
                    </label>
                    <p class="t_c_agreement">
                      By continuing, you agree to
                      <span @click.prevent="redirectTNC()"
                        >Terms and Conditions.</span
                      >
                    </p>
                    <p>ငွေပေးချေပြီးပါက ဟောစာတမ်းအား (၃) ရက်အတွင်း 'အဖြေများ' စာမျက်နှာတွင် ဝင်ရောက် ကြည့်ရှုနိုင်ပါသည်။</p>
                    <!-- <p>
                      ဉာဏ်ပူဇော်ခ
                      <del>၁၅၀၀၀</del> ၁၂၇၅၀
                      ကျပ် ကျသင့်ပါမည်။
                    </p> -->
                    <p>
                      <input
                        @click.prevent="paymentProvider()"
                        :disabled="disabled"
                        type="submit"
                        class="woocommerce-Button button mm-font __mm"
                        name="save_account_details"
                        value="အတည်ပြုမည်"
                      />
                    </p>
                  </form>
                  <form
                    id="business-form"
                    role="form"
                    v-if="getCurrentCategory.id === 267"
                  >
                    <p class="mm-font __mm" align="center">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>
                    <label class="form-group">
                      <span class="mm-font __mm">လုပ်ငန်းရှင်အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="owner_name"
                        v-model="business.owner_name"
                        required
                      />
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>
                      <md-datepicker
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        v-model="business.birth_date"
                      >
                        <label class="date__picker" v-if="!business.birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">လုပ်ကိုင်မည့်လုပ်ငန်း</span>
                      <select
                        class="mm-font __mm"
                        name="business_type"
                        v-model="business.business_type"
                        required
                      >
                        <option value="" selected hidden>
                          လုပ်ငန်းအမျိုးအစား
                        </option>
                        <option value="ကြော်ငြာ ၊မီဒီယာနှင့်ဆက်သွယ်ရေးလုပ်ငန်း">
                          ကြော်ငြာ ၊မီဒီယာနှင့်ဆက်သွယ်ရေးလုပ်ငန်း
                        </option>
                        <option
                          value="စိုက်ပျိုးရေးလုပ်ငန်း၊ငါးလုပ်ငန်းနှင့်သစ်တောလုပ်ငန်း"
                        >
                          စိုက်ပျိုးရေးလုပ်ငန်း၊ငါးလုပ်ငန်းနှင့်သစ်တောလုပ်ငန်း
                        </option>
                        <option value="မော်တော်ယာဉ်နှင့်လေကြောင်းလုပ်ငန်း">
                          မော်တော်ယာဉ်နှင့်လေကြောင်းလုပ်ငန်း
                        </option>
                        <option value="ဘဏ် ၊ ငွေကြေး နှင့်အာမခံလုပ်ငန်း">
                          ဘဏ် ၊ ငွေကြေး နှင့်အာမခံလုပ်ငန်း
                        </option>
                        <option value="ဆောက်လုပ်ရေးလုပ်ငန်း">
                          ဆောက်လုပ်ရေးလုပ်ငန်း
                        </option>
                        <option value="ပညာရေးလုပ်ငန်း">ပညာရေးလုပ်ငန်း</option>
                        <option
                          value="ဖျော်ဖြေရေး၊ပွဲအခမ်းအနားများနှင့်အားကစားလုပ်ငန်း"
                        >
                          ဖျော်ဖြေရေး၊ပွဲအခမ်းအနားများနှင့်အားကစားလုပ်ငန်း
                        </option>
                        <option value="ကျန်းမာရေးဝန်ဆောင်မှုလုပ်ငန်း">
                          ကျန်းမာရေးဝန်ဆောင်မှုလုပ်ငန်း
                        </option>
                        <option value="ဟိုတယ်နှင့်ဧည့်ဝန်ဆောင်မှုလုပ်ငန်း">
                          ဟိုတယ်နှင့်ဧည့်ဝန်ဆောင်မှုလုပ်ငန်း
                        </option>
                        <option value="နည်းပညာနှင့်ဆက်သွယ်ရေးလုပ်ငန်း">
                          နည်းပညာနှင့်ဆက်သွယ်ရေးလုပ်ငန်း
                        </option>
                        <option value="ကုန်ထုတ်လုပ်မှု နှင့်သိုလှောင်လုပ်ငန်း">
                          ကုန်ထုတ်လုပ်မှု နှင့်သိုလှောင်လုပ်ငန်း
                        </option>
                        <option
                          value="စွမ်းအင် နှင့် သတ္တုတူးဖော်ထုတ်လုပ်ရေးလုပ်ငန်း"
                        >
                          စွမ်းအင် နှင့် သတ္တုတူးဖော်ထုတ်လုပ်ရေးလုပ်ငန်း
                        </option>
                        <option
                          value="အစိုးရမဟုတ်သောလူမှုအကျိုးပြုအဖွဲ့အစည်းများ"
                        >
                          အစိုးရမဟုတ်သောလူမှုအကျိုးပြုအဖွဲ့အစည်းများ
                        </option>
                        <option
                          value="အိမ်ခြံမြေနှင့် အထွေအထွေအကျိုးတော်ဆောင်လုပ်ငန်း"
                        >
                          အိမ်ခြံမြေနှင့် အထွေအထွေအကျိုးတော်ဆောင်လုပ်ငန်း
                        </option>
                        <option value="ဝန်ထမ်းရွေးချယ်ခန့်ထားရေးလုပ်ငန်း">
                          ဝန်ထမ်းရွေးချယ်ခန့်ထားရေးလုပ်ငန်း
                        </option>
                        <option
                          value="လက်မှုအနုပညာ ၊ အလှကုန် နှင့် ဖက်ရှင် လုပ်ငန်း"
                        >
                          လက်မှုအနုပညာ ၊ အလှကုန် နှင့် ဖက်ရှင် လုပ်ငန်း
                        </option>
                        <option
                          value="အရောင်းကိုယ်စားလှယ်၊လက်လီ၊လူသုံးကုန်နှင့်စားသောက်ကုန်လုပ်ငန်း"
                        >
                          အရောင်းကိုယ်စားလှယ်၊လက်လီ၊လူသုံးကုန်နှင့်စားသောက်ကုန်လုပ်ငန်း
                        </option>
                        <option
                          value="ကူးသန်းရောင်းဝယ်ရေး နှင့် သယ်ယူပိုဆောင်ရေးလုပ်ငန်း"
                        >
                          ကူးသန်းရောင်းဝယ်ရေး နှင့် သယ်ယူပိုဆောင်ရေးလုပ်ငန်း
                        </option>
                        <option value="ခရီးသွားဝန်ဆောင်မှုလုပ်ငန်း">
                          ခရီးသွားဝန်ဆောင်မှုလုပ်ငန်း
                        </option>
                        <option value="အခြားလုပ်ငန်းများ">
                          အခြားလုပ်ငန်းများ
                        </option>
                      </select>
                      <input
                        type="text"
                        class="form-control mm-font"
                        name="business_detail"
                        v-model="business.business_detail"
                        placeholder="လုပ်ငန်းအသေးစိတ်"
                      />
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          gap: 10px;
                        "
                      >
                        <select
                          v-model="business.address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '1')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions1"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <select
                          v-model="business.address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships1.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships1"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရွာ/ လမ်း အသေးစိတ်"
                        v-model="business.address"
                        required
                      />
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm"
                        >ဆက်သွယ်ရမည့်ဖုန်းနံပါတ်</span
                      >
                      <input
                        type="number"
                        class="form-control"
                        name="phone_number"
                        v-model="business.phone_number"
                        @input="onlyDigit($event)"
                        placeholder="09xxxxxxxxx"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="isErrorBusiness.phone_number"
                      >
                        {{ isErrorBusiness.phone_number }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေ့သား(လုပ်ငန်းရှင်)</span>
                      <select
                        class="mm-font __mm"
                        name="nyih_tha"
                        v-model="business.nyih_tha"
                        required
                      >
                        <option value="" class="__mm" selected>
                          နေ့နံရွေးချယ်ပါ
                        </option>
                        <option value="တနင်္ဂနွေ" class="__mm">
                          တနင်္ဂနွေ
                        </option>
                        <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                        <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                        <option value="ဗုဒ္ဓဟူး" class="__mm">ဗုဒ္ဓဟူး</option>
                        <option value="ရာဟု" class="__mm">ရာဟု</option>

                        <option value="ကြာသပတေး" class="__mm">ကြာသပတေး</option>
                        <option value="သောကြာ" class="__mm">သောကြာ</option>
                        <option value="စနေ" class="__mm">စနေ</option>
                      </select>
                    </label>
                    <p>
                      <input
                        @click.prevent="paymentProvider()"
                        :disabled="disabled"
                        type="submit"
                        class="woocommerce-Button button mm-font __mm"
                        name="save_account_details"
                        value="အတည်ပြုမည်"
                      />
                    </p>
                  </form>
                  <form
                    id="child-form"
                    role="form"
                    style="display: block"
                    v-if="getCurrentCategory.id === 10"
                  >
                    <p class="mm-font __mm" align="center">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>
                      <md-datepicker
                        v-model="oneyear.birth_date"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        required
                      >
                        <label class="date__picker" v-if="!oneyear.birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                    </label>

                    <label class="form-group">
                      <span class="mm-font __mm">မွေးချိန်</span>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: 1fr 2fr;
                          gap: 10px;
                        "
                      >
                        <select
                          class="mm-font __mm"
                          v-model="birth_am_pm"
                          required
                        >
                          <option value="" hidden>နံနက်/ည</option>
                          <option value="နံနက်">နံနက်ပိုင်း</option>
                          <option value="ည">ညနေပိုင်း</option>
                        </select>
                        <select
                          class="mm-font __mm"
                          v-model="birth_clock"
                          required
                        >
                          <option value="" hidden>အချိန်</option>
                          <option
                            v-for="t in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                            :key="t"
                            :value="t + ' နာရီ'"
                          >
                            {{ t }} နာရီ
                          </option>
                        </select>
                      </div>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        v-model="oneyear.name"
                        required
                      />
                    </label>

                    <label class="form-group">
                      <span for class="mm-font __mm">မွေးရပ်</span>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          gap: 10px;
                        "
                      >
                        <select
                          v-model="oneyear.birth_place_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '2')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions2"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <select
                          v-model="oneyear.birth_place_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships2.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships2"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ်"
                        v-model="oneyear.birth_place"
                        required
                      />
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">အလုပ်အကိုင်</span>
                      <div
                        style="
                          display: grid;
                          grid-template-rows: 1fr 1fr;
                          gap: 5px;
                        "
                      >
                        <select
                          name="job"
                          class="mm-font __mm"
                          v-model="oneyear.career"
                          required
                        >
                          <option value="" selected hidden>
                            အလုပ်အကိုင် အမျိုးအစား
                          </option>
                          <option value="အစိုးရဝန်ထမ်း">အစိုးရဝန်ထမ်း</option>
                          <option value="ကုမ္ပဏီဝန်ထမ်း">ကုမ္ပဏီဝန်ထမ်း</option>
                          <option value="ကိုယ်ပိုင်စီးပွားရေး">
                            ကိုယ်ပိုင်စီးပွားရေး
                          </option>
                          <option value="ကျောင်းသား/သူ">ကျောင်းသား/သူ</option>
                          <option value="အခြား">အခြား</option>
                        </select>
                        <input
                          type="text"
                          class="form-control"
                          name="job_detail"
                          v-model="oneyear.career_detail"
                          placeholder="အလုပ်ကိုင်အသေးစိတ်"
                        />
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div
                        style="
                          display: grid;
                          grid-template-columns: 1fr 1fr;
                          gap: 10px;
                        "
                      >
                        <select
                          v-model="oneyear.address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange($event, '1')"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions1"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <select
                          v-model="oneyear.address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships1.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships1"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ်"
                        v-model="oneyear.address"
                        required
                      />
                    </label>
                    <input
                      type="radio"
                      name="marital_status"
                      value="Yes"
                      v-model="oneyear.marital_status"
                      required
                    />
                    <span for class="mm-font __mm">အိမ်ထောင်ရှိ</span>
                    <input
                      type="radio"
                      name="marital_status"
                      value="No"
                      v-model="oneyear.marital_status"
                      required
                    />
                    <span for class="mm-font __mm">အိမ်ထောင်မရှိ</span>
                    <br />
                    <br />

                    <label class="form-group">
                      <span for class="mm-font __mm">နေ့နံ</span>
                      <select
                        name="g_birth_day"
                        v-model="oneyear.nyih_nan"
                        class="mm-font __mm"
                        required
                      >
                        <option value="" class="__mm" selected>
                          နေ့နံရွေးချယ်ပါ
                        </option>
                        <option value="တနင်္ဂနွေ" class="__mm">
                          တနင်္ဂနွေ
                        </option>
                        <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                        <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                        <option value="ဗုဒ္ဓဟူး" class="__mm">ဗုဒ္ဓဟူး</option>
                        <option value="ရာဟု" class="__mm">ရာဟု</option>

                        <option value="ကြာသပတေး" class="__mm">ကြာသပတေး</option>
                        <option value="သောကြာ" class="__mm">သောကြာ</option>
                        <option value="စနေ" class="__mm">စနေ</option>
                      </select>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm"
                        >အဓိကသိချင်သောအကြောင်းအရာ</span
                      >
                      <input
                        type="text"
                        class="form-control"
                        name="about"
                        v-model="oneyear.about"
                        maxlength="1000"
                        required
                      />
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm"
                        >ဆက်သွယ်ရမည့်ဖုန်းနံပါတ်</span
                      >
                      <input
                        type="text"
                        class="form-control"
                        name="phone_number"
                        v-model="oneyear.phone_number"
                        @input="onlyDigit($event)"
                        placeholder="09xxxxxxxxx"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="isErrorOneyear.phone_number"
                      >
                        {{ isErrorOneyear.phone_number }}
                      </div>
                    </label>
                    <p>
                      <input
                        @click.prevent="paymentProvider()"
                        :disabled="disabled"
                        type="submit"
                        class="woocommerce-Button button mm-font __mm"
                        name="save_account_details"
                        value="အတည်ပြုမည်"
                        style=""
                      />
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  </section>
</template>
<style>
input {
  background-color: red;
}

.input-container {
  display: flex;
  border: 1px solid #000;
  background-color: #f2eff7;
  color: #3e1e68;
  border-radius: 25px;
  padding: 8px 0px 0px 10px;
}

.md-field.md-theme-default:after {
  background-color: rgba(0, 0, 0, 0);
}

.md-button.md-theme-default {
  margin: 0px 16px 0px 0px;
}
</style>

<script>
import { mapGetters } from "vuex";
import { Horo, HTTP } from "@core/lib/http-common";
import { checkFormModel, getFormData } from "@core/lib/form-data";
import { citizenPay, makePayment, onePay } from "../js/payment";
import { getDivisions, getTownships } from "../js/addressInfo";
import moment from "moment";
// import Datepicker from 'vue-material-datepicker';
import { EventBus } from "../../public/js/eventBus";
import { validatePhoneNumber } from "../utils/validationPhone";

export default {
  components: {
    // datepicker : Datepicker
  },
  name: `Special`,
  data() {
    return {
      datepicker: null,
      divisions1: [],
      divisions2: [],
      townships1: [],
      townships2: [],
      birth_am_pm: "",
      birth_clock: "",
      actionBtnMethod: "",
      disabled: false,
      res_status: 0,
      message: "",
      onepayPhoneNumber: "",
      // promocode: "",
      datePickerOptions: {
        format: "DD/MM/YYYY",
        useCurrent: false,
      },
      love: {
        g_name: "",
        g_birth_day: "",
        g_birth_date: "",
        g_address: "",
        g_address_division: "",
        g_address_township: "",
        b_name: "",
        b_birth_day: "",
        b_birth_date: "",
        b_address: "",
        b_address_division: "",
        b_address_township: "",
        phone_number: "",
        order_id: "0",
        user_id: "0",
        price: "0",
      },
      child: {
        birth_date: "",
        birth_time: "",
        father_name: "",
        mother_name: "",
        birth_place: "",
        birth_place_division: "",
        birth_place_township: "",
        nyih_nan: "",
        order_id: "0",
        address: "",
        address_division: "",
        address_township: "",
        phone_number: "",
        gender: "",
        user_id: "0",
        price: "0",
      },
      oneyear: {
        birth_date: "",
        birth_time: "",
        birth_place: "",
        birth_place_division: "",
        birth_place_township: "",
        nyih_nan: "",
        career: "",
        career_detail: "",
        marital_status: "",
        phone_number: "",
        order_id: "0",
        user_id: "0",
        about: "",
        address: "",
        address_division: "",
        address_township: "",
        price: "0",
      },
      business: {
        owner_name: "",
        user_id: "0",
        birth_date: "",
        business_type: "",
        business_detail: "",
        phone_number: "",
        address: "",
        address_division: "",
        address_township: "",
        nyih_tha: "",
        order_id: "0",
        price: "0",
      },
      isErrorChild: {},
      isErrorLove: {},
      isErrorBusiness: {},
      isErrorOneyear: {},
      isMM: false,
    };
  },
  computed: {
    ...mapGetters({
      getCurrentCategory: "categoryStore/getCurrentCategory",
      getUserToken: "userStore/getUserToken",
      getResponse: "userStore/getResponse",
    }),

    disablePastDates() {
      const today = new Date();
      return (date) => new Date(date) >= today;
    },
  },

  async created() {
    this.divisions1 = await getDivisions();
    this.divisions2 = { ...this.divisions1 };
    this.actionBtnMethod = this.$store.state.paymentName;
    this.onepayPhoneNumber =
      this.$store.state.paymentName == "onepay"
        ? this.$store.state.onepayPhoneNumber
        : "";

    this.$store.dispatch(
      "categoryStore/singleCategory",
      this.$route.params.categoryId,
    );
  },

  mounted() {
    setTimeout(() => {
      if (this.$refs.datepicker) {
        const input = this.$refs.datepicker.$el?.querySelector("input");
        if (input) {
          input.setAttribute("readonly", "true");
          console.log("Readonly attribute set on datepicker input.");
        } else {
          console.log("Input element not found inside datepicker.");
        }
      } else {
        console.log("Datepicker ref is STILL not available after delay.");
      }
    }, 500);
    this.getLocale();
  },

  watch: {
    "$route.params.categoryId": {
      immediate: true,
      handler(routeCategoryId) {
        console.log("routeCategoryId", routeCategoryId);

        if (
          !this.getCurrentCategory?.id ||
          this.getCurrentCategory.id !== Number(routeCategoryId)
        ) {
          this.$store.dispatch("categoryStore/singleCategory", routeCategoryId);
        }
      },
    },
    "oneyear.birth_date"(updatedDate) {
      let formattedDate = moment(updatedDate).format("YYYY-MM-DD");

      return formattedDate;
    },
    birth_am_pm: function (value) {
      let val = value + " " + this.birth_clock;
      switch (this.getCurrentCategory.id) {
        case 10:
          this.oneyear.birth_time = val;
          break;
        case 11:
          this.child.birth_time = val;
          break;
      }
    },
    birth_clock: function (value) {
      let val = this.birth_am_pm + " " + value;
      switch (this.getCurrentCategory.id) {
        case 10:
          this.oneyear.birth_time = val;
          break;
        case 11:
          this.child.birth_time = val;
          break;
      }
    },
  },

  methods: {
    getLocale() {
      window.ma.callNativeAPI("getLocale", {}, (res) => {
        this.isMM = res.language === "my-MM";
      });
    },

    async handleDivisionChange($event, division_id) {
      let nrc_id =
        $event.target.options[$event.target.selectedIndex].dataset.nrc;
      let townships = await getTownships(nrc_id);
      if (division_id == "1") {
        this.townships1 = townships;
      } else if (division_id == "2") {
        this.townships2 = townships;
      }
    },

    redirectTNC() {
      this.$router.push("/category/terms_and_conditions");
    },

    paymentProvider() {
      if (this.getCurrentCategory.id === 11) {
        this.validateForm();
      }
      if (this.getCurrentCategory.id === 275) {
        this.validateFormLove();
      }
      if (this.getCurrentCategory.id === 267) {
        this.isErrorBusiness.phone_number = validatePhoneNumber(
          this.business.phone_number,
        );
      }
      if (this.getCurrentCategory.id === 10) {
        this.isErrorOneyear.phone_number = validatePhoneNumber(
          this.oneyear.phone_number,
        );
      }
      if (this.getCurrentCategory.id === 11 && Object.values(this.isErrorChild).some((v) => v)) {
        return;
      }
      if (this.getCurrentCategory.id === 275 && Object.values(this.isErrorLove).some((v) => v)) {
        return;
      }
      if (this.getCurrentCategory.id === 267 && Object.values(this.isErrorBusiness).some((v) => v)) {
        return;
      }
      if (this.getCurrentCategory.id === 10 && Object.values(this.isErrorOneyear).some((v) => v)) {
        return;
      }
      let getPaymentName = this.actionBtnMethod;
      switch (getPaymentName) {
        case "mpitesan":
          this.makePayment();
          break;
        case "onepay":
          this.onePayProvider();
          break;
        case "citizenpay":
          this.citizenPayProvicer();
          break;
        case "bppay":
          this.bpPay();
          break;
        default:
          this.precreate();
          break;
      }
    },

    async citizenPayProvicer() {
      if (this.child.birth_time == "") {
        this.child.birth_time = " ";
      }
      if (this.oneyear.birth_time == "") {
        this.oneyear.birth_time = " ";
      }

      if (this.getCurrentCategory.id === 275 && checkFormModel(this.love)) {
        this.disabled = true;
        this.love.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.love);
        formdata.append("user_phone", this.love.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "love",
          // phone_number:
          //   this.onepayPhoneNumber == ""
          //     ? this.direct.phone_number
          //     : this.onepayPhoneNumber,
        };
        await citizenPay([
          "1875/love/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
              // console.log(data);
              // this.$store.state.order_id = data.order_id;
              // this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 11 &&
        checkFormModel(this.child)
      ) {
        this.disabled = true;
        this.child.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.child);
        formdata.append("user_phone", this.child.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "child",
          // phone_number:
          //   this.onepayPhoneNumber == ""
          //     ? this.direct.phone_number
          //     : this.onepayPhoneNumber,
        };
        await citizenPay([
          "1875/childNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
              // console.log(data);
              // this.$store.state.order_id = data.order_id;
              // this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 10 &&
        checkFormModel(this.oneyear)
      ) {
        this.disabled = true;
        this.oneyear.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.oneyear);
        formdata.append("user_phone", this.oneyear.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "oneyear",
          // phone_number:
          //   this.onepayPhoneNumber == ""
          //     ? this.direct.phone_number
          //     : this.onepayPhoneNumber,
        };
        await citizenPay([
          "1875/oneyear/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 267 &&
        checkFormModel(this.business)
      ) {
        this.disabled = true;
        this.business.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.business);
        formdata.append("user_phone", this.business.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "business",
          // phone_number:
          //   this.onepayPhoneNumber == ""
          //     ? this.direct.phone_number
          //     : this.onepayPhoneNumber,
        };
        await citizenPay([
          "1875/businessNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
              // console.log(data);
              // this.$store.state.order_id = data.order_id;
              // this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async onePayProvider() {
      if (this.child.birth_time == "") {
        this.child.birth_time = " ";
      }
      if (this.oneyear.birth_time == "") {
        this.oneyear.birth_time = " ";
      }

      if (this.getCurrentCategory.id === 275 && checkFormModel(this.love)) {
        this.disabled = true;
        this.love.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.love);
        formdata.append("user_phone", this.love.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "love",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.direct.phone_number
              : this.onepayPhoneNumber,
        };
        await onePay([
          "1875/love/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 11 &&
        checkFormModel(this.child)
      ) {
        this.disabled = true;
        this.child.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.child);
        formdata.append("user_phone", this.child.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "child",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.direct.phone_number
              : this.onepayPhoneNumber,
        };
        await onePay([
          "1875/childNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 10 &&
        checkFormModel(this.oneyear)
      ) {
        this.disabled = true;
        this.oneyear.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.oneyear);
        formdata.append("user_phone", this.oneyear.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "oneyear",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.direct.phone_number
              : this.onepayPhoneNumber,
        };
        await onePay([
          "1875/oneyear/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 267 &&
        checkFormModel(this.business)
      ) {
        this.disabled = true;
        this.business.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.business);
        formdata.append("user_phone", this.business.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "business",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.direct.phone_number
              : this.onepayPhoneNumber,
        };
        await onePay([
          "1875/businessNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              // this.$router.push({
              //   name: "paymentPortal",
              // });
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async bpPay() {
      if (this.child.birth_time == "") {
        this.child.birth_time = " ";
      }
      if (this.oneyear.birth_time == "") {
        this.oneyear.birth_time = " ";
      }

      if (this.getCurrentCategory.id === 275 && checkFormModel(this.love)) {
        this.disabled = true;
        this.love.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.love);
        formdata.append("user_phone", this.love.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "love",
          payment_name: this.actionBtnMethod,
          phone_number: this.love.phone_number,
          // promocode: this.promocode,
        };
        await makePayment([
          "1875/love/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "PWA BPPay" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 11 &&
        checkFormModel(this.child)
      ) {
        this.disabled = true;
        this.child.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.child);
        formdata.append("user_phone", this.child.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "child",
          // promocode: this.promocode,
          phone_number: this.child.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/childNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "PWA BPPay" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 10 &&
        checkFormModel(this.oneyear)
      ) {
        this.disabled = true;
        if (this.oneyear.phone_number == "09251569702") {
          this.oneyear.price = 1;
        } else {
          this.oneyear.price = this.getCurrentCategory.price;
        }
        let formdata = getFormData(this.oneyear);
        formdata.append("user_phone", this.oneyear.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "oneyear",
          // promocode: this.promocode,
          phone_number: this.oneyear.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/oneyear/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "PWA BPPay" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 267 &&
        checkFormModel(this.business)
      ) {
        this.disabled = true;
        this.business.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.business);
        formdata.append("user_phone", this.business.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "business",
          // promocode: this.promocode,
          phone_number: this.business.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/businessNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "PWA BPPay" },
                });
              }
              moment(this.birth_date).format("YYYY-MM-DD");
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async makePayment() {
      if (this.child.birth_time == "") {
        this.child.birth_time = " ";
      }
      if (this.oneyear.birth_time == "") {
        this.oneyear.birth_time = " ";
      }

      if (this.getCurrentCategory.id === 275 && checkFormModel(this.love)) {
        this.disabled = true;
        this.love.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.love);
        formdata.append("user_phone", this.love.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "love",
          payment_name: this.actionBtnMethod,
          phone_number: this.love.phone_number,
          // promocode: this.promocode,
        };
        await makePayment([
          "1875/love/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 11 &&
        checkFormModel(this.child)
      ) {
        this.disabled = true;
        this.child.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.child);
        formdata.append("user_phone", this.child.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "child",
          // promocode: this.promocode,
          phone_number: this.child.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/childNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 10 &&
        checkFormModel(this.oneyear)
      ) {
        this.disabled = true;
        if (this.oneyear.phone_number == "09251569702") {
          this.oneyear.price = 1;
        } else {
          this.oneyear.price = this.getCurrentCategory.price;
        }
        let formdata = getFormData(this.oneyear);
        formdata.append("user_phone", this.oneyear.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "oneyear",
          // promocode: this.promocode,
          phone_number: this.oneyear.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/oneyear/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else if (
        this.getCurrentCategory.id === 267 &&
        checkFormModel(this.business)
      ) {
        this.disabled = true;
        this.business.price = this.getCurrentCategory.price;
        let formdata = getFormData(this.business);
        formdata.append("user_phone", this.business.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "business",
          // promocode: this.promocode,
          phone_number: this.business.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/businessNaming/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.getCurrentCategory.price,
        ])
          .then((data) => {
            // console.log(data);
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
              moment(this.birth_date).format("YYYY-MM-DD");
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    precreate() {
      if (this.child.birth_time == "") {
        this.child.birth_time = " ";
      }
      if (this.oneyear.birth_time == "") {
        this.oneyear.birth_time = " ";
      }

      if (this.getCurrentCategory.id === 275 && checkFormModel(this.love)) {
        const lovePhoneError = validatePhoneNumber(this.love.phone_number);
        if (lovePhoneError) {
          this.$swal("Oops", lovePhoneError, "error");
          return;
        }
        this.disabled = true;
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "love",
        })
          .then((response) => {
            const res = response.data;
            this.love.order_id = res.order_id;
            this.love.user_id = res.user_id;
            this.love.price = this.getCurrentCategory.price;
            let formdata = getFormData(this.love);
            formdata.set("price", res.amount);
            formdata.append(
              "user_phone",
              this.getResponse.customer_info.msisdn,
            );
            Horo.post("1875/love/horoscope", formdata).then((response) => {
              this.res_status = response.data.status;

              // new kbzpay mini_app api
              window.ma.callNativeAPI(
                "startPay",
                {
                  prepayId: res.prepay_id,
                  orderInfo: res.order_info,
                  sign: res.sign_app,
                  signType: "SHA256",
                  disableNewCheckout: "false",
                  tradeType: "MINIAPP",
                },
                (res) => {
                  console.log("startPay api res: ", res);
                  if (res.resultCode == 1) {
                    EventBus.$emit("clear-cache");
                    console.log("startpaysucess");
                    if (!this.isMM) {
                      this.$swal(
                        "Success",
                        "Purchased. Please contact 09456880335 if you have any problems.",
                        "success",
                      );
                      this.$router.push({ name: "home" });
                    }
                    if (this.isMM) {
                      this.$swal(
                        "အောင်မြင်ပါသည်",
                        "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                        "success",
                      );
                      this.$router.push({ name: "home" });
                    }
                  } else {
                    if (!this.isMM) {
                      this.$swal("Fail", "Please try again", "error");
                      this.disabled = false;
                    }
                    if (this.isMM) {
                      this.$swal("မအောင်မြင်ပါ", "ထပ်မံကြိုးစားပေးပါ", "error");
                      this.disabled = false;
                    }
                  }
                },
              );
              // this.kbzpay.startPay(
              //   res.prepay_id,
              //   res.order_info,
              //   res.sign_app,
              //   ({ resultCode, lang }) => {
              //     if (resultCode == 1) {
              //       if (lang == "en") {
              //         this.$swal("Success", "Your Purchase Success", "success");
              //         this.$router.push({ name: "home" });
              //       }
              //       if (lang == "my") {
              //         this.$swal("အောင်မြင်ပါသည်", "ဝယ်ယူပြီးပါပြီ", "success");
              //         this.$router.push({ name: "home" });
              //       }
              //     }
              //     if (resultCode == 2) {
              //       if (lang == "en") {
              //         this.$swal("Failed", "Your Purchase Failed", "error");
              //         this.disabled = false;
              //       }
              //       if (lang == "my") {
              //         this.$swal("မအောင်မြင်ပါ", "ထပ်မံကြိုးစားပေးပါ", "error");
              //         this.disabled = false;
              //       }
              //     }
              //   },
              //   () => {
              //     this.$swal("Failed", "Your Purchase Failed", "error");
              //     this.disabled = false;
              //   }
              // );
            });
          })
          .catch((error) => {
            console.log(error);
            this.message = "Something went wrong";
          });
      } else if (
        this.getCurrentCategory.id === 11 &&
        checkFormModel(this.child)
      ) {
        const childPhoneError = validatePhoneNumber(this.child.phone_number);
        if (childPhoneError) {
          this.$swal("Oops", childPhoneError, "error");
          return;
        }
        this.disabled = true;
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "child",
        })
          .then((response) => {
            const res = response.data;
            this.child.order_id = res.order_id;
            this.child.user_id = res.user_id;
            this.child.price = this.getCurrentCategory.price;
            let formdata = getFormData(this.child);
            formdata.set("price", res.amount);
            formdata.append(
              "user_phone",
              this.getResponse.customer_info.msisdn,
            );
            Horo.post("1875/childNaming/horoscope", formdata).then(
              (response) => {
                this.res_status = response.data.status;

                // new kbzpay mini_app api
                window.ma.callNativeAPI(
                  "startPay",
                  {
                    prepayId: res.prepay_id,
                    orderInfo: res.order_info,
                    sign: res.sign_app,
                    signType: "SHA256",
                    disableNewCheckout: "false",
                    tradeType: "MINIAPP",
                  },
                  (res) => {
                    console.log("startPay api res: ", res);
                    if (res.resultCode == 1) {
                      EventBus.$emit("clear-cache");
                      console.log("startpaysucess");
                      if (!this.isMM) {
                        this.$swal(
                          "Success",
                          "Purchased. Please contact 09456880335 if you have any problems.",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                      if (this.isMM) {
                        this.$swal(
                          "အောင်မြင်ပါသည်",
                          "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                    } else {
                      if (!this.isMM) {
                        this.$swal("Fail", "Please try again", "error");
                        this.disabled = false;
                      }
                      if (this.isMM) {
                        this.$swal(
                          "မအောင်မြင်ပါ",
                          "ထပ်မံကြိုးစားပေးပါ",
                          "error",
                        );
                        this.disabled = false;
                      }
                    }
                  },
                );
                // this.kbzpay.startPay(
                //   res.prepay_id,
                //   res.order_info,
                //   res.sign_app,
                //   ({ resultCode, lang }) => {
                //     if (resultCode == 1) {
                //       if (lang == "en") {
                //         this.$swal(
                //           "Success",
                //           "Your Purchase Success",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "အောင်မြင်ပါသည်",
                //           "ဝယ်ယူပြီးပါပြီ",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //     }
                //     if (resultCode == 2) {
                //       if (lang == "en") {
                //         this.$swal("Failed", "Your Purchase Failed", "error");
                //         this.disabled = false;
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "မအောင်မြင်ပါ",
                //           "ထပ်မံကြိုးစားပေးပါ",
                //           "error"
                //         );
                //         this.disabled = false;
                //       }
                //     }
                //   },
                //   () => {
                //     this.$swal("Failed", "Your Purchase Failed", "error");
                //     this.disabled = false;
                //   }
                // );
              },
            );
          })
          .catch((error) => {
            console.log(error);
            this.message = "Something went wrong";
          });
      } else if (
        this.getCurrentCategory.id === 10 &&
        checkFormModel(this.oneyear)
      ) {
        const oneyearPhoneError = validatePhoneNumber(this.oneyear.phone_number);
        if (oneyearPhoneError) {
          this.$swal("Oops", oneyearPhoneError, "error");
          return;
        }
        this.disabled = true;
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "oneyear",
        })
          .then((response) => {
            const res = response.data;
            this.oneyear.order_id = res.order_id;
            this.oneyear.user_id = res.user_id;
            this.oneyear.price = this.getCurrentCategory.price;
            let formdata = getFormData(this.oneyear);
            formdata.set("price", res.amount);
            formdata.append(
              "user_phone",
              this.getResponse.customer_info.msisdn,
            );
            Horo.post("1875/oneyear/horoscope", formdata).then((response) => {
              this.res_status = response.data.status;

              // new kbzpay mini_app api
              window.ma.callNativeAPI(
                "startPay",
                {
                  prepayId: res.prepay_id,
                  orderInfo: res.order_info,
                  sign: res.sign_app,
                  signType: "SHA256",
                  disableNewCheckout: "false",
                  tradeType: "MINIAPP",
                },
                (res) => {
                  console.log("startPay api res: ", res);
                  if (res.resultCode == 1) {
                    EventBus.$emit("clear-cache");
                    console.log("startpaysucess");
                    if (!this.isMM) {
                      this.$swal(
                        "Success",
                        "Purchased. Please contact 09456880335 if you have any problems.",
                        "success",
                      );
                      this.$router.push({ name: "home" });
                    }
                    if (this.isMM) {
                      this.$swal(
                        "အောင်မြင်ပါသည်",
                        "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                        "success",
                      );
                      this.$router.push({ name: "home" });
                    }
                  } else {
                    if (!this.isMM) {
                      this.$swal("Fail", "Please try again", "error");
                      this.disabled = false;
                    }
                    if (this.isMM) {
                      this.$swal("မအောင်မြင်ပါ", "ထပ်မံကြိုးစားပေးပါ", "error");
                      this.disabled = false;
                    }
                  }
                },
              );

              // this.kbzpay.startPay(
              //   res.prepay_id,
              //   res.order_info,
              //   res.sign_app,
              //   ({ resultCode, lang }) => {
              //     if (resultCode == 1) {
              //       if (lang == "en") {
              //         this.$swal("Success", "Your Purchase Success", "success");
              //         this.$router.push({ name: "home" });
              //       }
              //       if (lang == "my") {
              //         this.$swal("အောင်မြင်ပါသည်", "ဝယ်ယူပြီးပါပြီ", "success");
              //         this.$router.push({ name: "home" });
              //       }
              //     }
              //     if (resultCode == 2) {
              //       if (lang == "en") {
              //         this.$swal("Failed", "Your Purchase Failed", "error");
              //         this.disabled = false;
              //       }
              //       if (lang == "my") {
              //         this.$swal("မအောင်မြင်ပါ", "ထပ်မံကြိုးစားပေးပါ", "error");
              //         this.disabled = false;
              //       }
              //     }
              //   },
              //   () => {
              //     this.$swal("Failed", "Your Purchase Failed", "error");
              //     this.disabled = false;
              //   }
              // );
            });
          })
          .catch((error) => {
            console.log(error);
            this.message = "Something went wrong";
          });
      } else if (
        this.getCurrentCategory.id === 267 &&
        checkFormModel(this.business)
      ) {
        const businessPhoneError = validatePhoneNumber(
          this.business.phone_number,
        );
        if (businessPhoneError) {
          this.$swal("Oops", businessPhoneError, "error");
          return;
        }
        this.disabled = true;
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: this.getCurrentCategory.id,
          amount: this.getCurrentCategory.price,
          category_name: "business",
        })
          .then((response) => {
            const res = response.data;
            this.business.order_id = res.order_id;
            this.business.user_id = res.user_id;
            this.business.price = this.getCurrentCategory.price;
            let formdata = getFormData(this.business);
            formdata.set("price", res.amount);
            formdata.append(
              "user_phone",
              this.getResponse.customer_info.msisdn,
            );
            Horo.post("1875/businessNaming/horoscope", formdata).then(
              (response) => {
                this.res_status = response.data.status;

                // new kbzpay mini_app api
                window.ma.callNativeAPI(
                  "startPay",
                  {
                    prepayId: res.prepay_id,
                    orderInfo: res.order_info,
                    sign: res.sign_app,
                    signType: "SHA256",
                    disableNewCheckout: "false",
                    tradeType: "MINIAPP",
                  },
                  (res) => {
                    console.log("startPay api res: ", res);
                    if (res.resultCode == 1) {
                      EventBus.$emit("clear-cache");
                      console.log("startpaysucess");
                      if (!this.isMM) {
                        this.$swal(
                          "Success",
                          "Purchased. Please contact 09456880335 if you have any problems.",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                      if (this.isMM) {
                        this.$swal(
                          "အောင်မြင်ပါသည်",
                          "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                    } else {
                      if (!this.isMM) {
                        this.$swal("Fail", "Please try again", "error");
                        this.disabled = false;
                      }
                      if (this.isMM) {
                        this.$swal(
                          "မအောင်မြင်ပါ",
                          "ထပ်မံကြိုးစားပေးပါ",
                          "error",
                        );
                        this.disabled = false;
                      }
                    }
                  },
                );
                // this.kbzpay.startPay(
                //   res.prepay_id,
                //   res.order_info,
                //   res.sign_app,
                //   ({ resultCode, lang }) => {
                //     if (resultCode == 1) {
                //       if (lang == "en") {
                //         this.$swal(
                //           "Success",
                //           "Your Purchase Success",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "အောင်မြင်ပါသည်",
                //           "ဝယ်ယူပြီးပါပြီ",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //     }
                //     if (resultCode == 2) {
                //       if (lang == "en") {
                //         this.$swal("Failed", "Your Purchase Failed", "error");
                //         this.disabled = false;
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "မအောင်မြင်ပါ",
                //           "ထပ်မံကြိုးစားပေးပါ",
                //           "error"
                //         );
                //         this.disabled = false;
                //       }
                //     }
                //   },
                //   () => {
                //     this.$swal("Failed", "Your Purchase Failed", "error");
                //     this.disabled = false;
                //   }
                // );
              },
            );
          })
          .catch((error) => {
            console.log(error);
            this.message = "Something went wrong";
          });
      } else {
        if (this.isMM) {
          this.$swal(
            "Oops",
            "လိုအပ်သည့်အချက်အလက်များ အားလုံးဖြည့်ပေးပါ။",
            "error",
          );
        } else {
          this.$swal("Oops", "You need to fill all fields.", "error");
        }
      }
    },

    validateForm() {
      this.isErrorChild = {};
      this.isErrorLove = {};

      if (this.child.birth_date === "" || !this.child.birth_date)
        this.isErrorChild.birth_date = "မွေးသက္ကရာဇ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.child.birth_time === "" || !this.child.birth_time)
        this.isErrorChild.birth_time = "မွေးချိန်ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (this.child.father_name === "" || !this.child.father_name)
        this.isErrorChild.father_name = "ဖခင်အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.child.nyih_nan === "" || !this.child.nyih_nan)
        this.isErrorChild.nyih_nan = "နေ့နံရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (this.child.mother_name === "" || !this.child.mother_name)
        this.isErrorChild.mother_name = "မိခင်အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.child.gender === "" || !this.child.gender)
        this.isErrorChild.gender = "ကျား/မ ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.child.birth_place_division === "" ||
        !this.child.birth_place_division ||
        this.child.birth_place_township === "" ||
        !this.child.birth_place_township ||
        this.child.birth_place === "" ||
        !this.child.birth_place
      )
        this.isErrorChild.birth_place = "မွေးရပ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (
        this.child.address_division === "" ||
        !this.child.address_division ||
        this.child.address_township === "" ||
        !this.child.address_township ||
        this.child.address === "" ||
        !this.child.address
      )
        this.isErrorChild.address = "နေရပ်လိပ်စာထည့်ရန်လိုအပ်ပါသည်။";
      this.isErrorChild.phone_number = validatePhoneNumber(
        this.child.phone_number,
      );
    },

    validateFormLove() {
      if (this.love.g_name === "" || !this.love.g_name)
        this.isErrorLove.g_name = "အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.love.g_birth_date === "" || !this.love.g_birth_date)
        this.isErrorLove.g_birth_date = "မွေးသက္ကရာဇ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.love.g_birth_day === "" || !this.love.g_birth_day)
        this.isErrorLove.g_birth_day = "နေ့နံရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.love.g_address === "" ||
        !this.love.g_address ||
        this.love.g_address_division === "" ||
        !this.love.g_address_division ||
        this.love.g_address_township === "" ||
        !this.love.g_address_township
      )
        this.isErrorLove.g_address = "နေရပ်လိပ်စာထည့်ရန်လိုအပ်ပါသည်။";

      if (this.love.b_name === "" || !this.love.b_name)
        this.isErrorLove.b_name = "အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.love.b_birth_date === "" || !this.love.b_birth_date)
        this.isErrorLove.b_birth_date = "မွေးသက္ကရာဇ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.love.b_birth_day === "" || !this.love.b_birth_day)
        this.isErrorLove.b_birth_day = "နေ့နံရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.love.b_address === "" ||
        !this.love.b_address ||
        this.love.b_address_division === "" ||
        !this.love.b_address_division ||
        this.love.b_address_township === "" ||
        !this.love.b_address_township
      )
        this.isErrorLove.b_address = "နေရပ်လိပ်စာထည့်ရန်လိုအပ်ပါသည်။";
      this.isErrorLove.phone_number = validatePhoneNumber(
        this.love.phone_number,
      );
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: inline;
  margin-top: 8px;
  margin-left: 3px;
}

.date__picker {
  margin-top: -8px !important;
  margin-left: 12px !important;
}
</style>
